"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleStep = SingleStep;
exports.default = exports.StepStyles = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _system = require("@mui/system");
var _Container = _interopRequireDefault(require("@mui/material/Container"));
var _Grid = _interopRequireDefault(require("@mui/material/Unstable_Grid2/Grid2"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _Button = _interopRequireDefault(require("../../elements/Button/Button"));
var _Link = _interopRequireDefault(require("../../elements/Link/Link"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _GridTwo = _interopRequireDefault(require("../../components/Grid/GridTwo/GridTwo"));
var _MarkdownList = _interopRequireDefault(require("../../components/MarkdownList/MarkdownList"));
var _excluded = ["stepImageSide", "singleStepData"],
  _excluded2 = ["headingCopy", "subheadingCopy", "buttonLabel", "heroImageUrl", "heroImageAlt", "buttonUrl", "stepOneData", "stepTwoData", "stepThreeData"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var HeroImage = _styledComponents.default.img(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  @media (min-width: ", ") {\n    max-height: 70vw;\n    width: 70%;\n    text-align: right !important;\n  }\n\n  @media (min-width: ", ") {\n    text-align: right !important;\n    width: 100%;\n  }\n"])), _bfBaseStyles.Breakpoints.m, _bfBaseStyles.Breakpoints.l);
var StyledSectionHeading = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    children = _ref.children;
  return _react.default.createElement(_Heading.default, {
    h1: true,
    teal: true,
    className: className
  }, " ", children, " ");
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n"])));
var StyledSectionSubheading = (0, _styledComponents.default)(function (_ref2) {
  var className = _ref2.className,
    children = _ref2.children;
  return _react.default.createElement(_Heading.default, {
    h3: true,
    className: className
  }, " ", children, " ");
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n"])));
var StepStyles = (0, _styledComponents.default)(_system.Box)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  margin-bottom: 40px;\n"])));
exports.StepStyles = StepStyles;
function SingleStep(_ref3) {
  var stepImageSide = _ref3.stepImageSide,
    singleStepData = _ref3.singleStepData,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return _react.default.createElement(_Grid.default, Object.assign({
    container: true,
    justifyContent: "space-between"
  }, props), _react.default.createElement(_Grid.default, {
    xs: 12,
    sm: 12,
    md: 6,
    lg: 6,
    display: "flex",
    alignItems: "center",
    textAlign: props.imageDirection,
    justifyContent: props.imageDirection ? 'flex-end' : 'auto'
  }, _react.default.createElement(HeroImage, {
    src: singleStepData.stepHeroImageUrl,
    alt: singleStepData.stepHeroImageAlt
  })), _react.default.createElement(_Grid.default, {
    container: true,
    xs: 12,
    sm: 12,
    md: 5,
    lg: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, _react.default.createElement(_system.Box, {
    style: {
      padding: '0 32px'
    }
  }, _react.default.createElement(StyledSectionSubheading, null, singleStepData.stepHeaderCopy), _react.default.createElement(_MarkdownList.default, {
    copy: singleStepData.stepSubheadingCopy
  }, singleStepData.stepSubheadingCopy))));
}
var BoxStyles = (0, _styledComponents.default)(_system.Box)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  padding-bottom: 32.5px; \n  padding-top: 32.5px;\n  background-image: url(", ");\n  background-color: ", ";\n  \n  @media (min-width: ", ") {\n    padding-bottom: 75px; \n    padding-top: 75px;\n  }\n"])), function (props) {
  return props.backgroundImageUrl;
}, function (props) {
  return props.heroBackgroundColor;
}, _bfBaseStyles.Breakpoints.m);
var ThreeStepSolution = function ThreeStepSolution(_ref4) {
  var headingCopy = _ref4.headingCopy,
    subheadingCopy = _ref4.subheadingCopy,
    buttonLabel = _ref4.buttonLabel,
    heroImageUrl = _ref4.heroImageUrl,
    heroImageAlt = _ref4.heroImageAlt,
    buttonUrl = _ref4.buttonUrl,
    stepOneData = _ref4.stepOneData,
    stepTwoData = _ref4.stepTwoData,
    stepThreeData = _ref4.stepThreeData,
    props = (0, _objectWithoutProperties2.default)(_ref4, _excluded2);
  return _react.default.createElement(BoxStyles, props, _react.default.createElement(_Container.default, Object.assign({
    maxWidth: false,
    disableGutters: true
  }, props), _react.default.createElement(_system.Box, {
    textAlign: "center"
  }, _react.default.createElement(StyledSectionHeading, {
    style: {
      textAlign: 'center'
    }
  }, headingCopy)), _react.default.createElement(StepStyles, null, _react.default.createElement(SingleStep, Object.assign({
    singleStepData: stepOneData
  }, props))), _react.default.createElement(StepStyles, null, _react.default.createElement(SingleStep, {
    singleStepData: stepTwoData,
    direction: 'row-reverse',
    mdOffset: "auto",
    sx: {
      display: {
        xs: 'none',
        md: 'flex'
      }
    }
  })), _react.default.createElement(StepStyles, null, _react.default.createElement(SingleStep, {
    singleStepData: stepTwoData,
    mdOffset: "auto",
    sx: {
      display: {
        xs: 'flex',
        md: 'none'
      }
    },
    justifyContent: "flex-end",
    imageDirection: true
  })), _react.default.createElement(StepStyles, null, _react.default.createElement(SingleStep, {
    singleStepData: stepThreeData
  })), _react.default.createElement(_system.Box, {
    textAlign: "center",
    justifyContent: "center"
  }, _react.default.createElement(_Link.default, {
    href: buttonUrl
  }, _react.default.createElement(_Button.default, {
    pink: true
  }, " ", buttonLabel, " ")))));
};
var _default = ThreeStepSolution;
exports.default = _default;